import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useClientAuthStore } from '@/store/useClientAuthStore';
import LoginPage from '@/pages/LoginPage';
import RegisterPage from '@/pages/RegisterPage';
import ForgotPasswordPage from '@/pages/ForgotPasswordPage';
import ResetPasswordPage from '@/pages/ResetPasswordPage';
import HomePage from '@/pages/HomePage';
import ServicesPage from '@/pages/ServicesPage';
import AppointmentsPage from '@/pages/AppointmentsPage';
import BookAppointmentPage from '@/pages/BookAppointmentPage';
import QuickBookPage from '@/pages/QuickBookPage';
import ProfilePage from '@/pages/ProfilePage';
import VehiclesPage from '@/pages/VehiclesPage';
import TestPage from '@/pages/TestPage';
import Layout from '@/components/Layout';

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { isAuthenticated } = useClientAuthStore();
  return isAuthenticated ? <>{children}</> : <Navigate to="/login" replace />;
};

function App() {
  const { isAuthenticated } = useClientAuthStore();

  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <Routes>
          {/* Rutas públicas */}
          <Route 
            path="/login" 
            element={isAuthenticated ? <Navigate to="/home" replace /> : <LoginPage />} 
          />
          <Route
            path="/register"
            element={isAuthenticated ? <Navigate to="/home" replace /> : <RegisterPage />}
          />
          <Route
            path="/forgot-password"
            element={isAuthenticated ? <Navigate to="/home" replace /> : <ForgotPasswordPage />}
          />
          <Route
            path="/reset-password/:token"
            element={isAuthenticated ? <Navigate to="/home" replace /> : <ResetPasswordPage />}
          />
          {/* Redirigir raíz al login */}
          <Route path="/" element={<Navigate to="/login" replace />} />

          {/* Rutas protegidas */}
          <Route path="/home" element={
            <ProtectedRoute>
              <Layout>
                <HomePage />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/services" element={
            <ProtectedRoute>
              <Layout>
                <ServicesPage />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/appointments" element={
            <ProtectedRoute>
              <Layout>
                <AppointmentsPage />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/book-appointment" element={
            <ProtectedRoute>
              <Layout>
                <BookAppointmentPage />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/quick-book" element={
            <ProtectedRoute>
              <QuickBookPage />
            </ProtectedRoute>
          } />
          
          <Route path="/profile" element={
            <ProtectedRoute>
              <Layout>
                <ProfilePage />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/vehicles" element={
            <ProtectedRoute>
              <Layout>
                <VehiclesPage />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/test" element={
            <ProtectedRoute>
              <Layout>
                <TestPage />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;